import React from 'react';
export function Hero() {
  return <section className="min-h-screen flex flex-col bg-[#FAF7F2] pt-6 sm:pt-10 md:pt-16" data-id="element-133">
      <div className="flex-1 flex items-center pt-28 pb-24 sm:py-6 md:py-20" data-id="element-134">
        <div className="max-w-[1400px] mx-auto px-12 sm:px-12 md:px-16 lg:px-18 w-full" data-id="element-135">
          {' '}
          <h1 className="font-light text-[#2C2416] text-[clamp(48px,8vw,96px)] leading-[0.95] tracking-[-3px] mb-6 font-['Inter']" data-id="element-136">
            Your Ecommerce Implementation{' '}
            <span className="text-[#D4A574]" data-id="element-137">Team</span>
          </h1>
          <p className="text-[#8B7355] text-xl max-w-2xl mb-8 leading-relaxed font-['Inter']" data-id="element-138">
            Design, development, migrations, email. 15 years behind every build.
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-139">
            <a href="/contact" className="bg-transparent border-2 border-[#2C2416] text-[#2C2416] px-9 py-4 rounded-full font-medium tracking-[0.5px] hover:scale-105 transition-all duration-300 hover:bg-[#2C2416] hover:text-[#FAF7F2] font-['Inter']" data-id="element-140">
              Get in touch
            </a>
          </div>
        </div>
      </div>
      {/* Hero Image Section - With padding and rounded corners */}
      <div className="w-full px-6 sm:px-10 md:px-[60px] mt-auto pb-0" data-id="element-141">
        <div className="relative w-full h-[300px] md:h-[400px] overflow-hidden rounded-2xl" data-id="element-142">
          {' '}
          <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/09/pink-salt-landscape.jpg" alt="Modern commerce workspace" className="w-full h-full object-cover" data-id="element-143" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#2C2416]/10 to-transparent opacity-30" data-id="element-144"></div>
        </div>
      </div>
    </section>;
}